import { Box } from '@material-ui/core'
import DescriptionIcon from '@material-ui/icons/Description'
import { get } from 'lodash'

import { formatDate } from '../../helpers/formatters'
import {
  ChildrenDocument,
  ChildrenDocumentAttachment,
  ChildrenDocumentMissing,
  DocumentType,
  FOLDER_NAME_TO_CATEGORY,
} from '../../models/document'
import { midGray } from '../../theme/colors'
import { TextRight } from '../Base/Base'
import { FlexBox } from '../Base/FlexBox'
import { Text } from '../Text/Text'
import { DocumentListGrid } from './DocumentList'
import { DocumentRowInfoStatus } from './DocumentRowInfoStatus'

interface DocumentRowItemProps {
  document: ChildrenDocument | ChildrenDocumentMissing
  refetchDocuments: () => Promise<any>
  onDocumentOpen?: (
    document: ChildrenDocument | ChildrenDocumentMissing,
    attachments?: ChildrenDocumentAttachment[]
  ) => React.ReactNode
  renderDocumentAction?: (
    document: ChildrenDocument | ChildrenDocumentMissing,
    attachments?: ChildrenDocumentAttachment[],
    refetchDocuments?: () => Promise<any>
  ) => React.ReactNode
}

export function DocumentRowItem({
  document,
  onDocumentOpen,
  renderDocumentAction,
  refetchDocuments,
}: DocumentRowItemProps) {
  const hasAttachments =
    'documentAttachmentVersions' in document && document.documentAttachmentVersions?.length > 0
  const effectiveDateSource =
    document.documentType === DocumentType.DRIVER_LICENSE && !hasAttachments
      ? 'metadata["DRIVER_LICENSE_ISSUE_DATE"]'
      : 'metadata[dateEffective]'
  const dateExpiredSource = hasAttachments ? "metadata['dateExpired']" : 'dateExpired'
  const latestAttachmentVersion =
    'documentAttachmentVersions' in document ? document.documentAttachmentVersions[0] : undefined
  const documentInfoObj = latestAttachmentVersion ? latestAttachmentVersion[0] : document

  return (
    <DocumentListGrid
      isItem
      onClick={onDocumentOpen ? () => onDocumentOpen?.(document, latestAttachmentVersion) : undefined}
    >
      <FlexBox gap="5px">
        <Box mt={-0.2}>
          <DescriptionIcon color={latestAttachmentVersion ? 'primary' : 'disabled'} />
        </Box>
        <Text variant="label2" fontColor={midGray}>
          {document.documentName}
        </Text>
      </FlexBox>

      <div>
        <DocumentRowInfoStatus item={documentInfoObj} />
      </div>

      <Text variant="paragraph1" fontColor={midGray}>
        {formatDateWithFallback(get(documentInfoObj, effectiveDateSource))}
      </Text>

      <Text variant="paragraph1" fontColor={midGray}>
        {formatDateWithFallback(get(documentInfoObj, dateExpiredSource))}
      </Text>

      <Text variant="paragraph1" fontColor={midGray}>
        {FOLDER_NAME_TO_CATEGORY[document.folderName]}
      </Text>

      <TextRight className="actions">
        {renderDocumentAction?.(document, latestAttachmentVersion, refetchDocuments)}
      </TextRight>
    </DocumentListGrid>
  )
}

function formatDateWithFallback(date?: string) {
  if (!date) return '-'
  return formatDate(date)
}
